import type { Language } from '@offer-catalog/services/i18n'
import { getCurrentLanguage } from '@offer-catalog/services/i18n'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { fetchAllCountries } from '@/api/ddfs/countries'
import { queryKeys } from '@/query/queryKeys'

interface UseCountriesOptions {
  prefetchOnMount?: boolean
}

export function useCountries({ prefetchOnMount = true }: UseCountriesOptions = {}) {
  const currentLanguage = getCurrentLanguage() as Language
  const [isOpen, setIsOpen] = useState(false)

  const countriesQuery = useQuery({
    enabled: prefetchOnMount || isOpen,
    queryKey: queryKeys.countries(currentLanguage),
    queryFn: () => fetchAllCountries(currentLanguage),
    staleTime: Number.POSITIVE_INFINITY,
  })

  return {
    countries: countriesQuery.data ?? [],
    totalCountries: countriesQuery.data?.length ?? 0,
    isCountriesError: countriesQuery.isError,
    isCountriesLoading: countriesQuery.isLoading,
    isOpen,
    setIsOpen,
  }
}
